import './App.css';
import QuoteList from './containers/QuoteList/QuoteList';

function App() {
  return (
    <QuoteList />
  );
}

export default App;
